import type { RootState } from "types/redux";

export const getInvitationPending = (state: RootState) => state.domains.shareMap.invitation.isPending;

export const getInvitationError = (state: RootState) => state.domains.shareMap.invitation.error;

export const getCollaborators = (state: RootState) => state.domains.shareMap.collaborators.collaborators;

export const getInvitees = (state: RootState) => state.domains.shareMap.collaborators.invitees;

export const getCollaboratorsPending = (state: RootState) => state.domains.shareMap.collaborators.isPending;

export const getCollaboratorsError = (state: RootState) => state.domains.shareMap.collaborators.error;

export const getShareLinkToken = (state: RootState) => state.domains.shareMap.shareLink.token;

export const getShareLinkIsPending = (state: RootState) => state.domains.shareMap.shareLink.isPending;

export const getShareLinkError = (state: RootState) => state.domains.shareMap.shareLink.error;

export const getIsOpenLinkPending = (state: RootState) => state.domains.shareMap.openLink.isPending;

export const getOpenLinkErrorStatus = (state: RootState) => state.domains.shareMap.openLink.errorStatus;

export const getOpenLinkInvite = (state: RootState) => state.domains.shareMap.openLink.data;
